// client/src/locales/en

const en = {
  translation: {
    form: {
      form_submit: "Submit form",
      make_a_choice: "Select an option",
      form_checked: "Yes",
      form_not_checked: "No"
    },
    general: {
      readMore: 'Read more',
      loading: 'Loading',
      close: 'Close'
    },
    blocks: {
      imageContainer: {
        error: 'Error loading image'
      },
      mapBlock: {
        visitWebsite: 'Visit website',
        map: 'Map',
        list: 'List'
      }
    },
    searchbar: {
      label: 'What are you looking for?',
      placeholder: 'Search by keyword'
    },
    header: {
      language: "Language"
    },
    footer: {
      links: {
        privacy: "Privacy",
        terms_conditions: "Terms & Conditions"
      },
      follow_us: "Follow us"
    },
    404: {
      title: "Sorry, we can't find the page you're looking for",
      description:
        "<p>It seems like the page doesn' exist (anymore) or perhaps is moved. Ofcourse you can always go back to our homepage.</p>",
      link: '/',
      homepage: 'To homepage'
    },
    searchResults: {
      title: 'What are you looking for?',
      formLabel: 'Your search',
      noSearchTerm: 'You haven\'t supplied a search term',
      types: {
        page: 'Page',
        news: 'News',
        stories: 'Story',
        vacancy: 'Vacancy'
      },
      noResults: 'No results found. Try again with these tips:',
      noResultsTips: {
        spelling: 'Check your spelling',
        describe: 'Describe your search differently',
        shorter: 'Make your search shorter'
      }
    },
    pagination: {
      previous: 'Previous',
      next: 'Next'
    },
    show_button: {
      more: 'Show more',
      less: 'Show less'
    }

  }
}

export default en;
